import React, {useEffect, useState, useRef} from 'react'
import classes from './ProgressBar.module.scss'

function ProgressBar({timeoutLengthSeconds, isActive, timeoutComplete}){

    let [renderProgresBar, setRenderProgressBar] = useState(true) 
    let elapsedTime = useRef(0)
    let [elapsedPercentage, setElapsedPercentage] = useState(0)
    let counter = useRef(null)
    let slideTimeout = null

    useEffect(() => {

        if(isActive){
    
            counter.current = setInterval(() => {
                let percentageComplete = parseInt((elapsedTime.current/timeoutLengthSeconds)*100)
                elapsedTime.current += 0.01;
                setElapsedPercentage(percentageComplete);
                if(percentageComplete > 99 && isActive){
                    timeoutComplete();
                }
            }, 10);
    
        }else{
            setTimeout(() => {                
                elapsedTime.current = 0
                setElapsedPercentage(0);
            }, 500);
                    
            if(counter.current != null){
                clearInterval(counter.current)
            }
        }

        console.log(elapsedPercentage)

    },[isActive])

	return (

		<>
            {
                (
                    renderProgresBar
                    ?
                    <span style={{width:`${elapsedPercentage}%`}} className={`${classes.ProgressBar}`} />
                    :
                    ""
                )
            }
            
		</>
		
	)
    
}

export default ProgressBar